/**
 * 모델
 * @window w_tb_e411w_06
 * @category 고장예방보전관리
 */

export class BreakMonthForecastModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 고장건수 1월
   *
   * **data type** varchar(8)
   */
  readonly cnt01: string;

  /**
   * 고장건수 2월
   *
   * **data type** varchar(8)
   */
  readonly cnt02: string;

  /**
   * 고장건수 3월
   *
   * **data type** varchar(8)
   */
  readonly cnt03: string;

  /**
   * 고장건수 4월
   *
   * **data type** varchar(8)
   */
  readonly cnt04: string;

  /**
   * 고장건수 5월
   *
   * **data type** varchar(8)
   */
  readonly cnt05: string;

  /**
   * 고장건수 6월
   *
   * **data type** varchar(8)
   */
  readonly cnt06: string;

  /**
   * 고장건수 7월
   *
   * **data type** varchar(8)
   */
  readonly cnt07: string;

  /**
   * 고장건수 8월
   *
   * **data type** varchar(8)
   */
  readonly cnt08: string;

  /**
   * 고장건수 9월
   *
   * **data type** varchar(8)
   */
  readonly cnt09: string;

  /**
   * 고장건수 10월
   *
   * **data type** varchar(8)
   */
  readonly cnt10: string;

  /**
   * 고장건수 11월
   *
   * **data type** varchar(8)
   */
  readonly cnt11: string;

  /**
   * 고장건수 12월
   *
   * **data type** varchar(8)
   */
  readonly cnt12: string;

  /**
   * 일자
   *
   * **data type** varchar(8)
   */
  readonly date: string;

  /**
   * 차이 1월
   *
   * **data type** varchar(8)
   */
  readonly gap01: string;

  /**
   * 차이 2월
   *
   * **data type** varchar(8)
   */
  readonly gap02: string;

  /**
   * 차이 3월
   *
   * **data type** varchar(8)
   */
  readonly gap03: string;

  /**
   * 차이 4월
   *
   * **data type** varchar(8)
   */
  readonly gap04: string;

  /**
   * 차이 5월
   *
   * **data type** varchar(8)
   */
  readonly gap05: string;

  /**
   * 차이 6월
   *
   * **data type** varchar(8)
   */
  readonly gap06: string;

  /**
   * 차이 7월
   *
   * **data type** varchar(8)
   */
  readonly gap07: string;

  /**
   * 차이 8월
   *
   * **data type** varchar(8)
   */
  readonly gap08: string;

  /**
   * 차이 9월
   *
   * **data type** varchar(8)
   */
  readonly gap09: string;

  /**
   * 차이 10월
   *
   * **data type** varchar(8)
   */
  readonly gap10: string;

  /**
   * 차이 11월
   *
   * **data type** varchar(8)
   */
  readonly gap11: string;

  /**
   * 차이 12월
   *
   * **data type** varchar(8)
   */
  readonly gap12: string;

  /**
   * 예측건수 1월
   *
   * **data type** varchar(8)
   */
  readonly predict01: string;

  /**
   * 예측건수 2월
   *
   * **data type** varchar(8)
   */
  readonly predict02: string;

  /**
   * 예측건수 3월
   *
   * **data type** varchar(8)
   */
  readonly predict03: string;

  /**
   * 예측건수 4월
   *
   * **data type** varchar(8)
   */
  readonly predict04: string;

  /**
   * 예측건수 5월
   *
   * **data type** varchar(8)
   */
  readonly predict05: string;

  /**
   * 예측건수 6월
   *
   * **data type** varchar(8)
   */
  readonly predict06: string;

  /**
   * 예측건수 7월
   *
   * **data type** varchar(8)
   */
  readonly predict07: string;

  /**
   * 예측건수 8월
   *
   * **data type** varchar(8)
   */
  readonly predict08: string;

  /**
   * 예측건수 9월
   *
   * **data type** varchar(8)
   */
  readonly predict09: string;

  /**
   * 예측건수 10월
   *
   * **data type** varchar(8)
   */
  readonly predict10: string;

  /**
   * 예측건수 11월
   *
   * **data type** varchar(8)
   */
  readonly predict11: string;

  /**
   * 예측건수 12월
   *
   * **data type** varchar(8)
   */
  readonly predict12: string;

  /**
   * 합계
   *
   * **data type** varchar(8)
   */
  readonly tot_cnt: string;

  /**
   * 차이
   *
   * **data type** varchar(8)
   */
  readonly tot_gap: string;

  /**
   * 예측
   *
   * **data type** varchar(8)
   */
  readonly tot_predict: string;


  constructor(data: any) {
    this.custcd = data.custcd || '';
    this.date = data.date || '';
    this.cnt01 = data.cnt01 || '';
    this.cnt02 = data.cnt02 || '';
    this.cnt03 = data.cnt03 || '';
    this.cnt04 = data.cnt04 || '';
    this.cnt05 = data.cnt05 || '';
    this.cnt06 = data.cnt06 || '';
    this.cnt07 = data.cnt07 || '';
    this.cnt08 = data.cnt08 || '';
    this.cnt09 = data.cnt09 || '';
    this.cnt10 = data.cnt10 || '';
    this.cnt11 = data.cnt11 || '';
    this.cnt12 = data.cnt12 || '';
    this.date = data.date || '';
    this.gap01 = data.gap01 || '';
    this.gap02 = data.gap02 || '';
    this.gap03 = data.gap03 || '';
    this.gap04 = data.gap04 || '';
    this.gap05 = data.gap05 || '';
    this.gap06 = data.gap06 || '';
    this.gap07 = data.gap07 || '';
    this.gap08 = data.gap08 || '';
    this.gap09 = data.gap09 || '';
    this.gap10 = data.gap10 || '';
    this.gap11 = data.gap11 || '';
    this.gap12 = data.gap12 || '';
    this.predict01 = data.predict01 || '';
    this.predict02 = data.predict02 || '';
    this.predict03 = data.predict03 || '';
    this.predict04 = data.predict04 || '';
    this.predict05 = data.predict05 || '';
    this.predict06 = data.predict06 || '';
    this.predict07 = data.predict07 || '';
    this.predict08 = data.predict08 || '';
    this.predict09 = data.predict09 || '';
    this.predict10 = data.predict10 || '';
    this.predict11 = data.predict11 || '';
    this.predict12 = data.predict12 || '';
    this.tot_cnt = data.tot_cnt || '';
    this.tot_gap = data.tot_gap || '';
    this.tot_predict = data.tot_predict || '';
  }
}
